import defaultSettings from '../../constants/settings';

export default {
    namespaced: true,
    state: {
        settings: {},
        initialized: false,
    },
    getters: {
        getAll(state) {
            return state.settings;
        },
        getIsInitialized(state) {
            return state.initialized;
        },
    },
    mutations: {
        setAll(state, settings) {
            Object.assign(state, {
                initialized: true,
                settings: {
                    ...defaultSettings,
                    ...settings,
                },
            });
        },
    },
    actions: {
        async fetchAll(context) {
            const settings = await context.dispatch('api/request', {
                service: 'setting',
                type: 'getAll',
            }, { root: true });

            if (settings) {
                context.commit('setAll', settings);
            }
        }, 
        
        async update(context, { bic_color, fic_color, fic_bic_color}) {
            const settings = await context.dispatch('api/request', {
                service: 'setting',
                type: 'update',
                data: {
                    fic_color,
                    bic_color,
                    fic_bic_color,
                }
            }, { root: true });

            if (settings) {
                context.commit('setAll', settings);

                // redraw graph
                context.dispatch('chart/forceRedrawChart', {}, { root: true });
            }
            return settings != null;
        },
    },
};
